module.exports = __webpack_public_path__ + "static/media/circle-plus.a110872a.svg";